// ** React Imports
import { useState, createContext } from 'react'

// ** Intl Provider Import
import { IntlProvider } from 'react-intl'

// ** Core Language Data
import messagesEn from '@assets/data/locales/en.json'
import messagesVi from '@assets/data/locales/vi.json'
import messagesCn from '@assets/data/locales/cn.json'

// ** User Language Data
import userMessagesEn from '@src/assets/data/locales/en.json'
import userMessagesVi from '@src/assets/data/locales/vi.json'
import userMessagesCn from '@src/assets/data/locales/cn.json'


// ** Menu msg obj
const menuMessages = {
  en: { ...messagesEn, ...userMessagesEn },
  cn: { ...messagesCn, ...userMessagesCn },
  vi: { ...messagesVi, ...userMessagesVi }
}
const LANGUAGE_STORAGE_KEY = 'locale'
const DEFAULT_LOCALE = 'vi'

const getInitialLocale = () => {
  const savedLocale = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
  return menuMessages[savedLocale] ? savedLocale : DEFAULT_LOCALE
}

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
  // ** States
  const [locale, setLocale] = useState(getInitialLocale)

  // ** Switches Language
  const switchLanguage = lang => {
    const selectedLocale = lang === 'vn' ? 'vi' : lang
    if (!menuMessages[selectedLocale]) return

    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, selectedLocale)
    setLocale(selectedLocale)
  }

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider key={locale} locale={locale} messages={menuMessages[locale]} defaultLocale='en'>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
